// Initialize route services so that they can watch routes
export function initialize(appInstance) {
  // Load all services in the `services/route/` path
  const routeServices = Object.keys(
    import.meta.glob('../services/route/*.js')
  ).map(key => key
    .replace(/^(.*\/)?services\//, 'service:')
    .replace(/\.js$/, '')
  );
  routeServices.forEach(routeService => {
    appInstance.lookup(routeService);
  });
}

export default {
  initialize,
};
